import React from 'react';

const id = obj => (obj && (obj.value || obj.id || obj)) || undefined;
const name = obj => obj.label || obj.name || obj;

/**
 * A simple selector of items.
 */
const Select = ({
  className,
  items,
  multiple,
  value,
  empty,
  onChange,
  testId,
  disabled,
  disabledText,
}) => {
  const hasItems = items && items.length;

  return (
    <select
      className={className}
      data-testid={testId}
      multiple={multiple}
      onChange={event => onChange && onChange(event.target.value)}
      value={hasItems ? id(value) : 'NA'}
      disabled={disabled || !hasItems}
    >
      {!hasItems && (
        <option value="NA">{disabledText || 'No options available'}</option>
      )}
      {empty && (
        <option key="" value="">
          {empty}
        </option>
      )}
      {hasItems &&
        items.map(item => (
          <option key={id(item)} value={id(item)}>
            {name(item)}
          </option>
        ))}
    </select>
  );
};
export default Select;
